import { render, staticRenderFns } from "./PhotoCard.vue?vue&type=template&id=527520f7&scoped=true"
import script from "./PhotoCard.vue?vue&type=script&lang=js"
export * from "./PhotoCard.vue?vue&type=script&lang=js"
import style0 from "./PhotoCard.vue?vue&type=style&index=0&id=527520f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527520f7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCardText,VCol,VDivider,VRow})
